import { Alert, Portal, Snackbar, Typography } from '@mui/material';
import * as Sentry from '@sentry/react';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { DEFAULT_PAGE } from './layout/Navigator/Navigator';

interface ErrorBoundaryState {
    hasError: boolean;
    history: RouteComponentProps['history'];
}

interface ErrorBoundaryProps extends RouteComponentProps {
    children: React.ReactNode;
    errorMessage: string;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, history: props.history };
    }

    componentDidCatch(error: Error) {
        this.setState({ hasError: true, history: this.state.history });
        Sentry.captureException(error);
        this.state.history.replace(DEFAULT_PAGE);
    }

    render() {
        return (
            <>
                {this.state.hasError ? (
                    <Portal>
                        <Snackbar
                            open={this.state.hasError}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            autoHideDuration={6000}
                            onClose={() => this.setState({ hasError: false })}
                        >
                            <Alert id="mui-alert" onClose={() => this.setState({ hasError: false })} severity={'error'}>
                                <Typography>{this.props.errorMessage}</Typography>
                            </Alert>
                        </Snackbar>
                    </Portal>
                ) : null}
                {this.props.children}
            </>
        );
    }
}

export default withRouter(ErrorBoundary);
